import { html } from "lit";
import { customElement, query } from "lit/decorators.js";
import rp, { BaseSidebar, Browser, BrowserEvent, BrowserState } from "@reporting/rp-app-host";
import { style } from "./sidebar.style";
import { AppBrowserAdapter } from "../adapters";
import { AppApplication } from "..";

@customElement('rp-app-sidebar')
export class Sidebar extends BaseSidebar<AppApplication> {

	static styles = [...BaseSidebar.styles, style];

	@query('rp-browser')
	browser: Browser;

	private _browserAdapter: AppBrowserAdapter;
    get browserAdapter() { 
		return this._browserAdapter ?? (this._browserAdapter = new AppBrowserAdapter());
    }

	firstUpdated() {
		this.browser.addEventListener('browser.state', this._onChangeState);
		this.browser.state = this.state?.appBrowser as BrowserState;
	}

	getState() {
		return {
			name: 'sidebar',
			appBrowser: this.browser?.getState(),
		}
	}

	_onChangeState = () => {
		this.dispatchStateEvent();
	}
	
	// refresh = () => {
	// 	this.browser.refresh();
	// }

	// toggleCollapse = () => {
	// 	this.browser.tree.toggleTreeCollapse();
	// };

	_onSelect = (e: BrowserEvent) => {
		rp.host.open(e.node.key, {title: e.node.value});
	}

	render = () => html`
		<div class="body">
			<rp-browser
				.adapter="${this.browserAdapter}"
				@browser.select="${this._onSelect}">
			</rp-browser>
		</div>
	`;

}
